import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import {
	PhonogramDeleteStatus,
	PhonogramDetailModel,
	PhonogramModel,
	PhonogramSaveModel,
	PhonogramType
} from "@/models/phonogram-manager-model";

class PhonogramManagerServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/phonogram" };

	public getPhonograms(params: {
		grapeSeedVersion: string | null;
		littleSeedVersion: string | null;
	}): Promise<PhonogramModel[]> {
		return this.request.get(this.url(), params);
	}

	public getPhonogramDetail(params: { id: string; phonogramType: PhonogramType }): Promise<PhonogramDetailModel> {
		const { id } = params;
		return this.request.get(this.url(`detail/${id}`), params);
	}

	public save(phonogram: PhonogramSaveModel): Promise<void> {
		return this.request.post(this.url("save"), phonogram);
	}
	public remove(params: { id: string; phonogramType: PhonogramType }): Promise<PhonogramDeleteStatus> {
		return this.request.del(this.url(`delete/${params.id}`), params);
	}
}

export const PhonogramManagerService = new PhonogramManagerServiceClass();
